import { Money } from '../../../../types';

export const minMoney = (acc: Money | undefined, next: Money): Money => {
	if (!acc) {
		return { ...next };
	}

	return next.amount < acc.amount
		? { ...next, currency: acc.currency ?? next.currency }
		: { ...acc, currency: acc.currency ?? next.currency };
};
